import React from "react";
import { Link } from "react-router-dom";

function ThankYou() {
  return (
    <div className="thank-you-page">
      <div className="thank-you-card">
        <div className="success-icon">✓</div>
        <h1>Thank You!</h1>
        <p className="thank-you-message">
          Your video message has been sent successfully.
          <br />
          Our sales team will review it and get back to you soon.
        </p>
        <div className="thank-you-actions">
          <Link to="/" className="home-link">Return to Home</Link>
        </div>
      </div>
    </div>
  );
}

export default ThankYou;
